import React, { useEffect, createElement } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function ThankYouPage() {
  useEffect(() => {
    document.title = 'Confirm Your Appointment | Lighthouse Capital Group';
    const metaDesc = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    metaDesc.setAttribute('content', "You're almost there. Confirm your Acquisition Strategy Session with Lighthouse Capital Group by accepting the calendar invite and replying to our confirmation email.");
    if (!document.querySelector('meta[name="description"]')) document.head.appendChild(metaDesc);
    const ogTitle = document.querySelector('meta[property="og:title"]') || document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.setAttribute('content', 'Confirm Your Appointment | Lighthouse Capital Group');
    if (!document.querySelector('meta[property="og:title"]')) document.head.appendChild(ogTitle);
    const ogDesc = document.querySelector('meta[property="og:description"]') || document.createElement('meta');
    ogDesc.setAttribute('property', 'og:description');
    ogDesc.setAttribute('content', 'Last step — confirm your Acquisition Strategy Session with Lighthouse Capital Group.');
    if (!document.querySelector('meta[property="og:description"]')) document.head.appendChild(ogDesc);
  }, []);
  return <div className="min-h-screen bg-[#0d1117] text-white flex flex-col" data-id="element-148">
      <Header data-id="element-149" />

      <main className="flex-grow px-4 py-10 md:py-16" data-id="element-150">
        <div className="max-w-2xl mx-auto text-center" data-id="element-151">
          {/* Progress Bar */}
          <div className="mb-10" data-id="element-152">
            <div className="flex items-center justify-center max-w-sm mx-auto mb-3" data-id="element-153">
              <div className="w-3.5 h-3.5 rounded-full bg-[#39d353] shrink-0" data-id="element-154" />
              <div className="flex-1 h-[3px] bg-[#39d353]" data-id="element-155" />
              <div className="w-3.5 h-3.5 rounded-full bg-[#39d353] shrink-0" data-id="element-156" />
              <div className="flex-1 h-[3px] bg-[#39d353]" data-id="element-157" />
              <div className="w-3.5 h-3.5 rounded-full bg-[#39d353] shrink-0" data-id="element-158" />
              <div className="flex-1 h-[3px] bg-[#39d353]" data-id="element-159" />
              <div className="w-3.5 h-3.5 rounded-full bg-[#39d353] shrink-0" data-id="element-160" />
              <div className="flex-1 h-[3px] bg-gray-600" data-id="element-161" />
              <div className="w-3.5 h-3.5 rounded-full border-2 border-gray-500 bg-transparent shrink-0" data-id="element-162" />
            </div>
            <p className="text-gray-400 text-sm" data-id="element-163">96% Complete</p>
          </div>

          {/* Logo */}
          <div className="mb-6" data-id="element-164">
            <img src="https://cdn.magicpatterns.com/uploads/2owrsuFxpnjj62oPqiekvz/image_1.png" alt="Lighthouse Capital Group" className="h-14 md:h-20 mx-auto object-contain" data-id="element-165" />
          </div>

          {/* Headline */}
          <p className="text-[#39d353] font-semibold text-base mb-3" data-id="element-166">
            You're Almost There
          </p>
          <h1 className="text-3xl md:text-[2.75rem] font-serif font-black text-white leading-tight mb-12 md:mb-16" data-id="element-167">
            Last step. Confirm Your Appointment.
          </h1>

          {/* Step 1 */}
          <div className="mb-12 md:mb-16" data-id="element-168">
            <p className="text-left text-lg md:text-xl mb-6" data-id="element-169">
              <span className="text-[#39d353] font-bold" data-id="element-170">Step 1: </span>
              <span className="text-white font-bold" data-id="element-171">
                Check your email &amp; accept the calendar invite
              </span>
            </p>

            {/* Calendar Invite Card */}
            <div className="bg-[#1e2330] rounded-2xl border border-[#2d3748] overflow-hidden" data-id="element-172">
              <div className="p-5 md:p-8" data-id="element-173">
                <div className="flex items-start gap-5" data-id="element-174">
                  {/* Calendar Date */}
                  <div className="shrink-0 w-14 h-14 md:w-16 md:h-16 rounded-xl bg-[#39d353] flex flex-col items-center justify-center text-white" data-id="element-175">
                    <span className="text-[10px] md:text-xs font-bold uppercase leading-none" data-id="element-176">
                      APR
                    </span>
                    <span className="text-xl md:text-2xl font-bold leading-none mt-0.5" data-id="element-177">
                      22
                    </span>
                  </div>

                  {/* Details */}
                  <div className="text-left flex-1" data-id="element-178">
                    <h3 className="text-white font-bold text-base md:text-lg mb-0.5" data-id="element-179">
                      Your Consultation with Lighthouse Capital
                    </h3>
                    <p className="text-gray-400 text-sm mb-3" data-id="element-180">
                      Invite to discuss candidacy
                    </p>
                    <p className="text-gray-400 text-sm mb-1" data-id="element-181">
                      When: Wed Apr 22, 2026 — 30 min
                    </p>
                    <p className="text-gray-400 text-sm mb-5" data-id="element-182">
                      Who:{' '}
                      <span className="text-white" data-id="element-183">
                        Lighthouse Capital Advisory Team
                      </span>
                    </p>

                    {/* RSVP Buttons */}
                    <div className="flex gap-2.5" data-id="element-184">
                      <span className="px-5 py-1.5 bg-[#39d353] text-white text-sm font-semibold rounded-md cursor-default" data-id="element-185">
                        Yes
                      </span>
                      <span className="px-5 py-1.5 bg-transparent text-gray-300 text-sm font-medium rounded-md border border-gray-500 cursor-default" data-id="element-186">
                        Maybe
                      </span>
                      <span className="px-5 py-1.5 bg-transparent text-gray-300 text-sm font-medium rounded-md border border-gray-500 cursor-default" data-id="element-187">
                        No
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="mb-16" data-id="element-188">
            <p className="text-left text-lg md:text-xl mb-2" data-id="element-189">
              <span className="text-[#39d353] font-bold" data-id="element-190">Step 2: </span>
              <span className="text-white font-bold" data-id="element-191">
                Reply to confirm your appointment.
              </span>
            </p>
            <p className="text-left text-gray-400 text-sm mb-6 max-w-xl" data-id="element-192">
              Our team will send a brief message to confirm your contact
              details. Please reply to verify we have the correct information.
              No confirmation. No call.
            </p>

            {/* Email Card */}
            <div className="bg-[#1e2330] rounded-2xl border border-[#2d3748] overflow-hidden" data-id="element-193">
              <div className="p-5 md:p-8 text-left" data-id="element-194">
                <h3 className="text-white font-bold text-base md:text-lg mb-1" data-id="element-195">
                  Your Lighthouse Capital Consultation is Confirmed
                </h3>
                <p className="text-gray-500 text-sm mb-6" data-id="element-196">
                  Lighthouse Capital Group · jack.bennett@lhcapitalgroup.com
                </p>

                <div className="text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-197">
                  <p data-id="element-198">Hi [First Name],</p>
                  <p data-id="element-199">
                    This is a quick note from the Lighthouse Capital team. We're
                    looking forward to our scheduled conversation.
                  </p>
                  <p data-id="element-200">
                    To confirm your spot, please reply{' '}
                    <strong className="text-white" data-id="element-201">"YES"</strong> to this
                    message. This ensures your time slot is secured and our team
                    is prepared for your call.
                  </p>
                  <p data-id="element-202">
                    If we don't receive a confirmation, we may need to
                    reallocate your time to another investor.
                  </p>
                  <p data-id="element-203">Talk soon,</p>
                  <p className="font-bold text-white" data-id="element-204">
                    The Lighthouse Capital Team
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-205" />
    </div>;
}